<div class="signature-preview-container">
  <div class="section intro">
    <h2>How Your Signature Will Appear</h2>
    <p class="content">
      Make sure your scanned signature is clear, easy to read, and fits well. It may appear in different field sizes depending on the document. If it doesn't meet the requirements, you may need to adjust and upload a new version.
    </p>
  </div>

  <div class="section examples">
    <h3>Examples of signature sizes</h3>
    <div class="signature-preview">
      <h5 class="signature-preview__title">Small</h5>
      <div class="preview-container preview-container--sm"><img [src]="signatureImage" alt="Signature Image" class="signature-overlay-image"></div>
    </div>
    <div class="signature-preview">
      <h5 class="signature-preview__title">Medium</h5>
      <div class="preview-container preview-container--md"><img [src]="signatureImage" alt="Signature Image" class="signature-overlay-image"></div>
    </div>
    <div class="signature-preview">
      <h5 class="signature-preview__title">Large</h5>
      <div class="preview-container preview-container--lg"><img [src]="signatureImage" alt="Signature Image" class="signature-overlay-image"></div>
    </div>
  </div>

  <div class="section tips">
    <h3>Tips for a Clear Signature</h3>

    <ul class="tips-list">
      <li>Clear and legible</li>
      <li>Properly sized — not too small or cropped</li>
      <li>Minimal white space around the signature</li>
      <li>Correct signer's file</li>
    </ul>
  </div>

  <div class="support-contact">
    Still need help? Contact Support at <a href="tel:8449131386" class="support-phone">(844) 913-1386</a>
  </div>
</div>
